import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../../components/feature/Navbar';
import Footer from '../../../../components/feature/Footer';

const AsrKurallariPage = () => {
  const CodeBlock = ({ title, code }: { title: string; code: string }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
      navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };
    return (
      <div className="bg-gray-900 rounded-xl p-6 overflow-x-auto">
        <div className="flex items-center justify-between mb-4">
          <span className="text-gray-400 text-sm">{title}</span>
          <button
            onClick={handleCopy}
            className="flex items-center space-x-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap
              bg-white/10 hover:bg-white/20 text-gray-300 hover:text-white"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'}></i>
            </div>
            <span>{copied ? 'Kopyalandı!' : 'Kopyala'}</span>
          </button>
        </div>
        <pre className="text-sm text-gray-100">{code}</pre>
      </div>
    );
  };

  const asrRules = [
    {
      id: '56a863a9-875e-4185-98a7-b882c64b5ce5',
      name: 'Office uygulamalarının yürütülebilir içerik oluşturmasını engelle',
      description: 'Word, Excel, PowerPoint gibi Office uygulamalarının .exe, .dll veya .scr dosyaları oluşturmasını önler.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: 'be9ba2d9-53ea-4cdc-84e5-9b1eeee46550',
      name: 'Office uygulamalarının alt süreç oluşturmasını engelle',
      description: 'Office uygulamalarının cmd.exe, powershell.exe gibi alt süreçler başlatmasını engeller.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: '3b576869-a4ec-4529-8536-b80a7769e899',
      name: 'Office uygulamalarının diğer süreçlere kod enjekte etmesini engelle',
      description: 'Office makrolarının diğer çalışan süreçlere zararlı kod enjekte etmesini önler.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: 'd4f940ab-401b-4efc-aadc-ad5f3c50688a',
      name: 'Office makrolarından Win32 API çağrılarını engelle',
      description: 'VBA makrolarının doğrudan Windows API fonksiyonlarını çağırmasını engeller.',
      severity: 'Orta',
      color: 'bg-amber-100 text-amber-700',
      platform: 'Client + Server',
    },
    {
      id: '5beb7efe-fd9a-4556-801d-275e5ffc04cc',
      name: 'Gizlenmiş (obfuscated) betiklerin yürütülmesini engelle',
      description: 'JavaScript, VBScript ve PowerShell betiklerindeki gizleme tekniklerini tespit eder ve engeller.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: 'd3e037e1-3eb8-44c8-a917-57927947596d',
      name: 'JavaScript/VBScript indirilen yürütülebilir içeriği başlatmasını engelle',
      description: 'Web tarayıcılarından indirilen betiklerin yürütülebilir dosyaları çalıştırmasını önler.',
      severity: 'Orta',
      color: 'bg-amber-100 text-amber-700',
      platform: 'Client + Server',
    },
    {
      id: '75668c1f-73b5-4cf0-bb93-3ecf5cb7cc84',
      name: 'Office uygulamalarının WMI aracılığıyla alt süreç oluşturmasını engelle',
      description: 'WMI (Windows Management Instrumentation) üzerinden süreç oluşturma girişimlerini engeller.',
      severity: 'Orta',
      color: 'bg-amber-100 text-amber-700',
      platform: 'Client + Server',
    },
    {
      id: 'e6db77e5-3df2-4cf1-b95a-636979351e5b',
      name: 'PSExec ve WMI komutlarından süreç oluşturmayı engelle',
      description: 'Yanal hareket için sıkça kullanılan PSExec ve WMI tabanlı uzaktan süreç oluşturmayı engeller.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: 'a8f5898e-1dc8-49a9-9878-85004b8a61e6',
      name: 'Sunucular için Webshell oluşturulmasını engelle',
      description: '2025 kritik kuralı: Exchange ve IIS gibi sunucularda webshell yazılmasını engelliyor. Sunucu saldırılarına karşı temel savunma.',
      severity: 'Kritik',
      color: 'bg-[#005A9E]/15 text-[#005A9E]',
      platform: 'Server Only',
    },
    {
      id: 'c0033c00-d16d-4114-a5a0-dc9b3a7d2ceb',
      name: 'Kopyalanmış veya taklit edilmiş sistem araçlarının kullanımını engelle',
      description: 'Saldırganların meşru Windows araçlarını (certutil, powershell vb.) farklı isimlerle kopyalayıp kullanmasını engelliyor.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
    {
      id: '33ddedf1-c6e0-47cb-833e-de6133960387',
      name: 'Güvenli Mod ile yeniden başlatmayı engelle',
      description: 'Güvenlik yazılımlarını devre dışı bırakmak için kullanılan "Güvenli Mod" ile yeniden başlatma taktiklerini engelliyor.',
      severity: 'Yüksek',
      color: 'bg-[#0078D4]/10 text-[#0078D4]',
      platform: 'Client + Server',
    },
  ];

  const deploymentPhases = [
    {
      phase: 'Keşif',
      duration: '1-2 Hafta',
      icon: 'ri-search-eye-line',
      color: 'bg-[#00BCF2]',
      steps: [
        'Mevcut uygulama envanterini çıkarın',
        'İş birimlerinden kritik uygulamaları belirleyin',
        'Baseline davranış analizi yapın',
        'Potansiyel uyumsuzlukları tespit edin',
      ],
    },
    {
      phase: 'Denetim (Audit)',
      duration: '2-4 Hafta',
      icon: 'ri-file-search-line',
      color: 'bg-[#0078D4]',
      steps: [
        'Tüm kuralları Audit modunda etkinleştirin',
        'Event Log verilerini toplayın ve analiz edin',
        'False positive oranlarını ölçün',
        'İstisna (exclusion) listelerini hazırlayın',
      ],
    },
    {
      phase: 'Kademeli Uygulama',
      duration: '2-4 Hafta',
      icon: 'ri-shield-check-line',
      color: 'bg-[#005A9E]',
      steps: [
        'Pilot grupta Block moduna geçin',
        'Yüksek öncelikli kurallardan başlayın',
        'Kullanıcı geri bildirimlerini toplayın',
        'İstisnaları ince ayar yapın',
      ],
    },
    {
      phase: 'Tam Dağıtım',
      duration: 'Sürekli',
      icon: 'ri-rocket-line',
      color: 'bg-[#003D6B]',
      steps: [
        'Tüm cihazlara Block modunda uygulayın',
        'Sürekli izleme ve raporlama kurun',
        'Yeni kural güncellemelerini takip edin',
        'Periyodik gözden geçirme yapın',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#0078D4] to-[#005A9E] overflow-hidden">
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
            }}
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link
              to="/edr"
              className="inline-flex items-center space-x-2 text-white/80 hover:text-white text-sm font-medium mb-8 cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span>EDR Sayfasına Dön</span>
            </Link>

            <div className="flex items-center space-x-3 mb-6">
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-md text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                Saldırı Yüzeyi Azaltma
              </span>
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-md text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                Microsoft Defender
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              ASR Kuralları ile Saldırı Yüzeyi Azaltma Stratejileri
            </h1>

            <p className="text-lg text-white/85 leading-relaxed mb-8 max-w-3xl">
              Attack Surface Reduction kurallarını yapılandırarak organizasyonunuzu bilinen saldırı vektörlerine karşı proaktif olarak koruyun.
            </p>

            <div className="flex items-center space-x-6 text-white/70 text-sm">
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-line text-base"></i>
                </div>
                <span>17 Ocak 2026</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-base"></i>
                </div>
                <span>11 dk okuma</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-user-line text-base"></i>
                </div>
                <span>Özgür Çebi</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Makale İçeriği */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-8">
          <motion.article
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <div className="text-gray-700 leading-relaxed space-y-6">

              {/* Giriş */}
              <p className="text-lg">
                Siber saldırıların büyük çoğunluğu, bilinen ve tekrarlayan saldırı vektörlerini kullanır: zararlı Office makroları, gizlenmiş betikler, kimlik bilgisi hırsızlığı araçları ve yanal hareket teknikleri. Microsoft Defender for Endpoint&apos;in <strong>Attack Surface Reduction (ASR)</strong> kuralları, bu bilinen saldırı yüzeylerini proaktif olarak daraltarak organizasyonunuzu korur.
              </p>

              {/* ASR Nedir? */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">ASR Kuralları Nedir?</h2>
                <p>
                  Attack Surface Reduction kuralları, Windows cihazlarda belirli yazılım davranışlarını hedefleyen güvenlik politikalarıdır. Bu kurallar, zararlı yazılımların sıklıkla kullandığı teknikleri — dosya oluşturma, süreç enjeksiyonu, kimlik bilgisi erişimi gibi — doğrudan işletim sistemi seviyesinde engeller.
                </p>
                <p>
                  ASR kuralları, geleneksel antivirüs imza taramasından farklı olarak <strong>davranış tabanlı</strong> çalışır. Bir dosyanın zararlı olup olmadığına bakmak yerine, uygulamaların potansiyel olarak tehlikeli eylemler gerçekleştirmesini önler.
                </p>

                <div className="grid md:grid-cols-3 gap-6 my-8">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center">
                    <div className="w-14 h-14 bg-[#0078D4]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                      <i className="ri-shield-line text-3xl text-[#0078D4]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Proaktif Koruma</h3>
                    <p className="text-sm text-gray-600">Saldırı gerçekleşmeden önce tehlikeli davranışları engeller</p>
                  </div>
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center">
                    <div className="w-14 h-14 bg-[#0078D4]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                      <i className="ri-eye-line text-3xl text-[#0078D4]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Davranış Tabanlı</h3>
                    <p className="text-sm text-gray-600">İmza yerine uygulama davranışlarını analiz eder</p>
                  </div>
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center">
                    <div className="w-14 h-14 bg-[#0078D4]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                      <i className="ri-settings-3-line text-3xl text-[#0078D4]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Esnek Yapılandırma</h3>
                    <p className="text-sm text-gray-600">Audit, Block ve Warn modları ile kademeli dağıtım</p>
                  </div>
                </div>
              </section>

              {/* Desteklenen Platformlar */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Desteklenen İşletim Sistemleri</h2>
                <p className="mb-6">
                  ASR kuralları, Windows 10 ve sonraki sürümlerde desteklenir. 2025 güncellemesi ile birlikte Windows Server 2025 desteği de eklenmiştir.
                </p>

                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-computer-line text-2xl text-blue-600"></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">Client (İstemci)</h3>
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Windows 10 (1709 ve sonrası)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Windows 11 (tüm sürümler)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Pro, Enterprise, Education sürümleri</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-[#005A9E]/10 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-server-line text-2xl text-[#005A9E]"></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">Server (Sunucu)</h3>
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span>Windows Server 2016 ve sonrası</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span>Windows Server 2019, 2022</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span><strong>Windows Server 2025</strong> (Yeni)</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="bg-amber-50 border-l-4 border-amber-500 rounded-r-xl p-6 mt-6">
                  <div className="flex items-start">
                    <i className="ri-information-line text-2xl text-amber-600 mr-4 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Client ve Server Ayrımı</h4>
                      <p className="text-gray-700 text-sm">
                        Microsoft, 2025 baselines ile birlikte bazı kuralları Client ve Server için farklı şekilde yapılandırmıştır. Örneğin, "Adobe Reader&apos;ın alt süreç oluşturmasını engelle" kuralı artık sunucularda önerilmiyor (çok fazla false positive üretiyor), sadece Client tarafında kalmalıdır.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Çalışma Modları */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">ASR Kural Modları</h2>
                <p className="mb-6">
                  Her ASR kuralı üç farklı modda çalıştırılabilir. Doğru mod seçimi, başarılı bir dağıtımın anahtarıdır.
                </p>

                <div className="space-y-4">
                  <div className="bg-gradient-to-r from-[#0078D4]/10 to-[#005A9E]/10 border-l-4 border-[#0078D4] rounded-r-xl p-6">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#0078D4] text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                        <i className="ri-file-search-line text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Audit Modu</h3>
                        <p className="text-gray-700 text-sm">
                          Kural tetiklendiğinde yalnızca olay kaydı oluşturur, eylemi engellemez. Dağıtım öncesi etki analizi için kullanılır. Tüm kuralları önce bu modda çalıştırmanız şiddetle önerilir.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-[#005A9E]/10 to-[#003D6B]/10 border-l-4 border-[#005A9E] rounded-r-xl p-6">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#005A9E] text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                        <i className="ri-forbid-line text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Block Modu</h3>
                        <p className="text-gray-700 text-sm">
                          Kural tetiklendiğinde eylemi engeller ve olay kaydı oluşturur. Üretim ortamında aktif koruma sağlar. Audit modunda yeterli test yapıldıktan sonra geçiş yapılmalıdır.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-orange-50 to-amber-50 border-l-4 border-orange-500 rounded-r-xl p-6">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-orange-500 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                        <i className="ri-alarm-warning-line text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Warn Modu (Uyarı)</h3>
                        <p className="text-gray-700 text-sm mb-3">
                          Kullanıcıya bir engel çıkarır ancak kullanıcı "Buna izin ver" diyerek devam edebilir. Kullanıcı farkındalığı oluşturmak ve geçiş dönemlerinde kullanılır.
                        </p>
                        <div className="bg-white/70 rounded-lg p-3 text-xs text-gray-600">
                          <strong>2026 Popüler Yapılandırma:</strong> IT çalışanları veya yazılım geliştiriciler gibi kuralın işlerini engelleyebileceği ama tamamen serbest bırakılmaması gereken gruplar için ideal. Kullanıcı eğitimi ve bilinçlendirme için de kullanılabilir.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 rounded-r-xl p-6 mt-6">
                  <div className="flex items-start">
                    <i className="ri-lightbulb-line text-2xl text-blue-600 mr-4 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Warn Modu Kullanım Senaryoları</h4>
                      <ul className="text-gray-700 text-sm space-y-1">
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-blue-600 mr-1 mt-0.5"></i>
                          <span>Geliştiriciler için PowerShell betik çalıştırma</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-blue-600 mr-1 mt-0.5"></i>
                          <span>IT ekipleri için yönetim araçları kullanımı</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-blue-600 mr-1 mt-0.5"></i>
                          <span>Audit&apos;ten Block&apos;a geçiş döneminde kullanıcı alışkanlığı oluşturma</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

              {/* Kritik ASR Kuralları */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Kritik ASR Kuralları&nbsp;</h2>
                <p className="mb-6">
                  Microsoft, 15&apos;ten fazla ASR kuralı sunar. Aşağıda en kritik ve yaygın kullanılan kuralları, 2025&apos;te eklenen yeni kurallar ile birlikte detaylı olarak inceliyoruz.
                </p>

                <div className="space-y-4">
                  {asrRules.map((rule, index) => (
                    <div
                      key={index}
                      className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-[#0078D4]/40 transition-colors"
                    >
                      <div className="flex items-start justify-between mb-3">
                        <h3 className="text-base font-bold text-gray-900 flex-1 pr-4">{rule.name}</h3>
                        <div className="flex flex-col items-end space-y-2">
                          <span className={`${rule.color} text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap`}>
                            {rule.severity}
                          </span>
                          <span className="bg-gray-100 text-gray-600 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap">
                            {rule.platform}
                          </span>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mb-3">{rule.description}</p>
                      <div className="bg-gray-50 rounded-lg px-4 py-2">
                        <code className="text-xs text-gray-500 font-mono">GUID: {rule.id}</code>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="bg-[#005A9E]/5 border-l-4 border-[#005A9E] rounded-r-xl p-6 mt-8">
                  <div className="flex items-start">
                    <i className="ri-star-line text-2xl text-[#005A9E] mr-4 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">2025 Yeni Eklenen Kritik Kurallar</h4>
                      <p className="text-gray-700 text-sm mb-3">
                        Yukarıdaki listede son üç kural (Webshell engelleme, taklit edilmiş araçlar, Güvenli Mod koruması) 2025&apos;te eklenen ve özellikle sunucu tarafı ve gelişmiş saldırı teknikleri için kritik öneme sahip kurallardır.
                      </p>
                      <ul className="text-gray-700 text-sm space-y-1">
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-[#005A9E] mr-1 mt-0.5"></i>
                          <span><strong>Webshell Engelleme:</strong> Exchange ve IIS sunucularına yönelik saldırılarda kritik</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-[#005A9E] mr-1 mt-0.5"></i>
                          <span><strong>Taklit Araçlar:</strong> Living-off-the-land (LOLBin) saldırılarını önler</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-arrow-right-s-line text-[#005A9E] mr-1 mt-0.5"></i>
                          <span><strong>Güvenli Mod:</strong> Ransomware&apos;in güvenlik yazılımlarını devre dışı bırakmasını engeller</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

              {/* Intune ile Yapılandırma */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Microsoft Defender Portal ile ASR Kurallarını Yapılandırma</h2>
                <p className="mb-6">
                  ASR kurallarını dağıtmanın en etkili yolu Microsoft Intune üzerinden Endpoint Security politikalarıdır. Tüm yapılandırma ve raporlama işlemleri <strong>Microsoft Defender portal</strong> (security.microsoft.com) üzerinden gerçekleştirilir.
                </p>

                <div className="bg-gradient-to-br from-[#0078D4]/5 to-[#005A9E]/5 rounded-2xl p-8 mb-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">Adım Adım Yapılandırma</h3>
                  <div className="space-y-6">
                    <div className="flex items-start">
                      <div className="w-10 h-10 bg-[#0078D4] text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                        1
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Microsoft Defender Portal&apos;a Gidin</h4>
                        <p className="text-gray-700 text-sm">
                          security.microsoft.com adresinden Endpoint Security → Attack Surface Reduction Rules → Create Policy yolunu izleyin.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <div className="w-10 h-10 bg-[#0078D4] text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                        2
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Platform ve Profil Seçin</h4>
                        <p className="text-gray-700 text-sm">
                          Platform: Windows 10 and later, Profile: Attack Surface Reduction Rules seçin.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <div className="w-10 h-10 bg-[#0078D4] text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                        3
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Kuralları Yapılandırın</h4>
                        <p className="text-gray-700 text-sm">
                          Her kural için Audit, Block, Warn veya Not Configured seçeneklerinden birini belirleyin. İlk dağıtımda tüm kuralları Audit modunda başlatın.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <div className="w-10 h-10 bg-[#0078D4] text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                        4
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">İstisnaları Tanımlayın</h4>
                        <p className="text-gray-700 text-sm">
                          Meşru iş uygulamalarının engellenmemesi için dosya ve klasör istisnalarını ekleyin. İstisnaları mümkün olduğunca dar kapsamlı tutun.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <div className="w-10 h-10 bg-[#0078D4] text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                        5
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Grup Ataması Yapın</h4>
                        <p className="text-gray-700 text-sm">
                          Politikayı önce pilot gruba, ardından kademeli olarak tüm organizasyona atayın.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PowerShell ile Yapılandırma */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4">PowerShell ile Yapılandırma</h3>
                <p className="text-gray-700 mb-4">
                  Hızlı test veya Intune dışı ortamlar için PowerShell kullanabilirsiniz:
                </p>

                <CodeBlock
                  title="PowerShell - ASR Kural Yapılandırması"
                  code={`# ASR Kuralları ve Karşılık Gelen Aksiyonlar (Dizi olarak tanımlama)
$ASR_Rules = @(
    "56a863a9-875e-4185-98a7-b882c64b5ce5", # Office uygulamalarının yürütülebilir içerik oluşturmasını engelle
    "be9ba2d9-53ea-4cdc-84e5-9b1eeee46550", # Office uygulamalarının alt süreçler oluşturmasını engelle
    "3b576869-a4ec-4529-8536-b80a7769e899", # Kopyalanmış sistem araçlarının kullanımını engelle (Yeni!)
    "5beb7efe-fd9a-4556-801d-275e5ffc04cc", # Gizlenmiş betiklerin yürütülmesini engelle
    "d3e037e1-3eb8-44c8-a917-57927947596d", # JS/VBS tarafından indirilen içeriğin yürütülmesini engelle
    "e6db77e5-3df2-4cf1-b95a-636979351e5b"  # PSExec ve WMI komutlarından kaynaklanan süreçleri engelle
)

# Tüm kurallar için aksiyon belirle: 
# 1: Block, 2: Audit, 6: Warn, 0: Disable
$Actions = @(2,2,2,2,2,2) 

# Kritik: Tüm listeyi tek seferde gönderiyoruz (Üzerine yazma hatasını engellemek için)
Set-MpPreference -AttackSurfaceReductionRules_Ids $ASR_Rules -AttackSurfaceReductionRules_Actions $Actions

# Sonuçları doğrulama (Gelişmiş çıktı)
$pref = Get-MpPreference
for($i=0; $i -lt $pref.AttackSurfaceReductionRules_Ids.Count; $i++) {
    Write-Host "Kural ID: $($pref.AttackSurfaceReductionRules_Ids[$i]) - Aksiyon: $($pref.AttackSurfaceReductionRules_Actions[$i])" -ForegroundColor Cyan
}`}
                />
              </section>

              {/* Dağıtım Stratejisi */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Kademeli Dağıtım Stratejisi</h2>
                <p className="mb-8">
                  ASR kurallarını doğrudan Block modunda dağıtmak, iş süreçlerini aksatabilir. Aşağıdaki 4 aşamalı strateji, güvenli ve kontrollü bir geçiş sağlar.
                </p>

                <div className="space-y-6">
                  {deploymentPhases.map((phase, index) => (
                    <div key={index} className="relative">
                      <div className="flex items-start">
                        <div className="flex flex-col items-center mr-6">
                          <div className={`w-14 h-14 ${phase.color} text-white rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg`}>
                            <i className={`${phase.icon} text-2xl`}></i>
                          </div>
                          {index < deploymentPhases.length - 1 && (
                            <div className="w-0.5 h-16 bg-gray-200 mt-2" />
                          )}
                        </div>
                        <div className="flex-1 pb-8">
                          <div className="flex items-center space-x-3 mb-2">
                            <h3 className="text-xl font-bold text-gray-900">
                              Aşama {index + 1}: {phase.phase}
                            </h3>
                            <span className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full whitespace-nowrap">
                              {phase.duration}
                            </span>
                          </div>
                          <div className="bg-white border border-gray-200 rounded-xl p-5">
                            <ul className="space-y-2">
                              {phase.steps.map((step, stepIndex) => (
                                <li key={stepIndex} className="flex items-start text-sm text-gray-700">
                                  <i className="ri-check-double-line text-[#0078D4] mr-2 mt-0.5 flex-shrink-0"></i>
                                  <span>{step}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Olay İzleme */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">ASR Olaylarını İzleme ve Raporlama</h2>
                <p className="mb-6">
                  ASR kurallarının etkinliğini ölçmek ve false positive&apos;leri tespit etmek için olay izleme kritik öneme sahiptir. Raporlama ekranları artık <strong>Exposure Management</strong> (Zafiyet Yönetimi) içine daha entegre çalışıyor.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-12 h-12 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-file-list-3-line text-2xl text-[#0078D4]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Windows Event Log</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span><strong>Event ID 1121:</strong> Block modunda engellenen eylem</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span><strong>Event ID 1122:</strong> Audit modunda tespit edilen eylem</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span><strong>Event ID 1129:</strong> Warn modunda kullanıcı kararı</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-12 h-12 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-bar-chart-box-line text-2xl text-[#0078D4]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Microsoft Defender Portal</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>ASR kuralları raporlama panosu</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Exposure Management entegrasyonu</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Cihaz ve kullanıcı bazlı detaylı analiz</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <CodeBlock
                  title="KQL - ASR Olay Analizi"
                  code={`/// Tüm ASR Kurallarının Özet Raporu
DeviceEvents
| where ActionType startswith "Asr"
| extend RuleId = tostring(parse_json(AdditionalFields).RuleId)
| summarize 
    Count = count() 
    by ActionType, DeviceName, RuleId
| sort by Count desc`}
                />
              </section>

              {/* İstisna Yönetimi */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">İstisna Yönetimi En İyi Uygulamaları</h2>

                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-xl mb-8">
                  <div className="flex items-start">
                    <i className="ri-alarm-warning-line text-2xl text-red-600 mr-4 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Dikkat: İstisnalar Saldırı Yüzeyini Genişletir</h4>
                      <p className="text-gray-700 text-sm">
                        Her eklenen istisna, potansiyel bir güvenlik açığıdır. İstisnaları mümkün olduğunca dar kapsamlı tutun ve düzenli olarak gözden geçirin.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-10 h-10 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-focus-3-line text-xl text-[#0078D4]"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900 block mb-2">Dosya Bazlı İstisna Tercih Edin</strong>
                      <p className="text-gray-700 text-sm">
                        Klasör bazlı geniş istisnalar yerine, spesifik dosya yolları ve hash değerleri kullanın. Örneğin <code className="bg-gray-100 px-1 rounded text-xs">C:\Tools\*</code> yerine <code className="bg-gray-100 px-1 rounded text-xs">C:\Tools\SpecificApp.exe</code> tercih edin.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-10 h-10 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-file-paper-2-line text-xl text-[#0078D4]"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900 block mb-2">İstisnaları Dokümante Edin</strong>
                      <p className="text-gray-700 text-sm">
                        Her istisna için neden eklendiğini, hangi iş sürecini desteklediğini ve kim tarafından onaylandığını kayıt altına alın.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-10 h-10 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-calendar-check-line text-xl text-[#0078D4]"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900 block mb-2">Periyodik Gözden Geçirme</strong>
                      <p className="text-gray-700 text-sm">
                        Her çeyrekte istisna listesini gözden geçirin. Artık kullanılmayan uygulamalar veya değişenmiş iş süreçleri nedeniyle gereksiz hale gelen istisnaları kaldırın.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-10 h-10 bg-[#0078D4]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-group-line text-xl text-[#0078D4]"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900 block mb-2">Grup Bazlı İstisna Uygulayın</strong>
                      <p className="text-gray-700 text-sm">
                        Tüm organizasyona geniş istisnalar eklemek yerine, yalnızca ilgili departman veya kullanıcı grubuna özel istisnalar tanımlayın.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Lisans Gereksinimleri */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Lisans Gereksinimleri&nbsp;</h2>
                <p className="mb-6">
                  ASR kuralları artık sadece E5 değil, <strong>Defender for Endpoint Plan 1</strong> (E3 lisansı ile gelen) ile de kullanılabilir. Ancak gelişmiş raporlama ve Advanced Hunting yetenekleri hala Plan 2 (E5) gerektiriyor.
                </p>

                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-white border-2 border-[#0078D4] rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-[#0078D4] rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-shield-check-line text-2xl text-white"></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">MDE Plan 1 (M 365 E3)</h3>
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Temel ASR kuralları (tüm kurallar)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Intune ile merkezi yönetim</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Temel raporlama ve olay görüntüleme</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#0078D4] mr-2 mt-0.5"></i>
                        <span>Windows Event Log entegrasyonu</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-[#005A9E] rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-[#005A9E] rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-shield-star-line text-2xl text-white"></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">Plan 2 (E5)</h3>
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span>Plan 1&apos;in tüm özellikleri</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span><strong>Advanced Hunting</strong> (KQL sorguları)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span><strong>Gelişmiş Raporlama</strong> ve analitik</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#005A9E] mr-2 mt-0.5"></i>
                        <span>Sentinel entegrasyonu ve SIEM yetenekleri</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 rounded-r-xl p-6 mt-6">
                  <div className="flex items-start">
                    <i className="ri-information-line text-2xl text-blue-600 mr-4 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Ücretsiz Seçenek</h4>
                      <p className="text-gray-700 text-sm">
                        Microsoft Defender Antivirus (Windows 10/11 ile ücretsiz gelen) ile temel ASR kurallarını Group Policy veya PowerShell ile yönetebilirsiniz. Ancak merkezi yönetim ve raporlama için Defender for Endpoint lisansı gereklidir.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Sonuç */}
              <section className="mb-12">
                <div className="bg-gradient-to-br from-[#0078D4] to-[#005A9E] text-white rounded-2xl p-8">
                  <h2 className="text-2xl font-bold mb-4">Özet ve Sonraki Adımlar</h2>
                  <p className="text-white/90 mb-6">
                    ASR kuralları, organizasyonunuzun saldırı yüzeyini önemli ölçüde daraltır. 2025 güncellemeleri ile birlikte sunucu tarafı koruma (Webshell engelleme), gelişmiş saldırı teknikleri (taklit edilmiş araçlar) ve Warn modu gibi yeni özellikler eklendi. Başarılı bir dağıtım için kademeli yaklaşım benimseyin: önce Audit, sonra Warn, en son Block moduna geçin. İstisnaları dar kapsamlı tutun ve sürekli izleme ile optimize edin.
                  </p>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="bg-white/15 backdrop-blur-sm rounded-xl p-4">
                      <div className="text-2xl font-bold mb-1">15+</div>
                      <div className="text-white/80 text-sm">Yerleşik ASR Kuralı</div>
                    </div>
                    <div className="bg-white/15 backdrop-blur-sm rounded-xl p-4">
                      <div className="text-2xl font-bold mb-1">%70</div>
                      <div className="text-white/80 text-sm">Saldırı Vektörü Azaltma</div>
                    </div>
                    <div className="bg-white/15 backdrop-blur-sm rounded-xl p-4">
                      <div className="text-2xl font-bold mb-1">3 Mod</div>
                      <div className="text-white/80 text-sm">Audit, Block, Warn</div>
                    </div>
                  </div>
                </div>
              </section>

              {/* İlgili Makaleler */}
              <section className="mt-16 pt-12 border-t-2 border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">İlgili Makaleler</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <Link
                    to="/edr"
                    className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-[#0078D4] transition-all"
                  >
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#0078D4] transition-colors">
                      Microsoft EDR Makaleleri
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Tüm EDR makalelerine göz atın ve uç nokta güvenliğini derinlemesine keşfedin
                    </p>
                    <span className="text-[#0078D4] text-sm font-medium">
                      Tümünü Gör <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </Link>

                  <Link
                    to="/sentinel/sentinel-kurulum-rehberi"
                    className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-[#0078D4] transition-all"
                  >
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#0078D4] transition-colors">
                      Sentinel Kurulum Rehberi
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      ASR olaylarını Sentinel ile izlemek için SIEM kurulumunu tamamlayın
                    </p>
                    <span className="text-[#0078D4] text-sm font-medium">
                      Devamını Oku <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </Link>
                </div>
              </section>

            </div>
          </motion.article>
        </div>
      </section>

      {/* Alt Navigasyon */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto px-8">
          <div className="flex items-center justify-between">
            <Link
              to="/edr"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all cursor-pointer text-gray-700 hover:text-[#0078D4]"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span className="text-sm font-medium whitespace-nowrap">EDR Sayfası</span>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all cursor-pointer text-gray-700 hover:text-[#0078D4]"
            >
              <span className="text-sm font-medium whitespace-nowrap">Ana Sayfa</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AsrKurallariPage;
